import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const PartnerAffiliateMessageCard = () => {
	const { t } = useTranslation("admin");

	return (
		<Card>
			<Card.Body>
				<h5>{t("enums.partner_types.AFFILIATE")}</h5>
				<div className="mt-2 d-flex flex-column">
					<strong>{t("modules.partner.field.hello.title")},</strong>
					<p className="mb-3">{t("modules.partner.field.document_links.title")}</p>
					<p className="mb-3">{t("modules.partner.field.contact_details.title")}</p>
					<p>Łukasz Kożuchowski, tel. 531 039 423, lukasz.kozuchowski@gopos.pl</p>
				</div>

				<div className="mt-2 d-flex flex-column">
					<strong>{t("modules.partner.field.useful_links.title")}</strong>
					<span>
						<a
							target="_blank"
							rel="noreferrer"
							href="https://docs.google.com/document/d/1f0zR2fv3BN5OsZ-Ztim1dwoKlGsVG24Sj7yriXEaMRQ/edit"
						>
							{t("modules.partner.field.recommend_gopos.title")}
						</a>
						<span>{` - ${t("modules.partner.field.recommend_gopos.description")}`}</span>
					</span>

					<span>
						<a
							target="_blank"
							rel="noreferrer"
							href="https://drive.google.com/file/d/11QcVOhPCvwsT9QT1aJSuq6Z087TSsVt_/view"
						>
							{t("modules.partner.field.booklet.title")}
						</a>
						<span>{` - ${t("modules.partner.field.booklet.description")}`}</span>
					</span>

					<span>
						<a
							target="_blank"
							rel="noreferrer"
							href="https://drive.google.com/file/d/18XBI_ngEbdAjVXs6VejQp8oMMF7gsuFu/view"
						>
							{t("modules.partner.field.price_list_extended_version.title")}
						</a>
						<span>{` - ${t("modules.partner.field.price_list_extended_version.description")}`}</span>
					</span>

					<span>
						<a
							target="_blank"
							rel="noreferrer"
							href="https://drive.google.com/file/d/1kX1pvtzgz_oUd9ot057SIS-p8psytRpl/view"
						>
							{t("modules.partner.field.price_list_short_version.title")}
						</a>
						<span>{` - ${t("modules.partner.field.price_list_short_version.description")}`}</span>
					</span>
					<span>
						<a target="_blank" rel="noreferrer" href="https://help.gopos.pl/pl/">
							{t("modules.partner.field.knowledge_base.title")}
						</a>
						<span>{` - ${t("modules.partner.field.knowledge_base.description")}`}</span>
					</span>
				</div>
			</Card.Body>
		</Card>
	);
};

export default PartnerAffiliateMessageCard;
